"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZhHantLocale = exports.EnLocale = exports.CUSTOMIZED = exports.COMPANY_NAME = exports.PHONE = exports.NAME = exports.CONTENT = exports.EMAIL = void 0;
exports.EMAIL = 'senderEmail';
exports.CONTENT = 'content';
exports.NAME = 'name';
exports.PHONE = 'phone';
exports.COMPANY_NAME = 'companyName';
exports.CUSTOMIZED = 'customized';
/**
 * The naming of the locale is the same with value storing in the DB
 * PLEASE don't change the name unintentionally
 */
exports.EnLocale = 'EN';
exports.ZhHantLocale = 'ZH_HANT';
